import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="ShowMoreArrowDown" size=32 />
 */

var ShowMoreArrowDown = function ShowMoreArrowDown() {
  return React.createElement(React.Fragment, null, React.createElement("svg", {
    width: "38",
    height: "20",
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M1 1L19 19L37 1",
    stroke: "black"
  })));
};

export default ShowMoreArrowDown;